<template>
    <div class="information-disclosure">
        <div class="information-detail tm-detail">
            <div class="tm-dltitle">借款人信息：</div>
            <p>
                <span>借款人类型</span>
                <small>{{ rxloanDetails.borrowerType }}</small>
            </p>
            <p>
                <span>借款人</span>
                <small>{{ rxloanDetails.borrowerName }}</small>
            </p>
            <p>
                <span>证件号码</span>
                <small>{{ rxloanDetails.borrowerIdNumber }}</small>
            </p>
            <!-- 自然人 0-->
            <div v-if="rxloanDetails.borrowerTypeCode != '1'">
                <p>
                    <span>工作性质</span>
                    <small>{{ rxloanDetails.workCase }}</small>
                </p>
            </div>
            <!-- 法人 1-->
            <div v-if="rxloanDetails.borrowerTypeCode != '0'">
                <p>
                    <span>所属行业</span>
                    <small>{{ rxloanDetails.corpIndustry }}</small>
                </p>
            </div>
            <p>
                <span>收入情况</span>
                <small>{{ rxloanDetails.incomeSource }}</small>
            </p>
            <p>
                <span>负债情况</span>
                <small>{{ rxloanDetails.debtCase }}</small>
            </p>
            <p>
                <span>在本平台逾期总次数</span>
                <small>{{ rxloanDetails.overdueNumber }}次</small>
            </p>
            <p>
                <span>在本平台逾期总金额</span>
                <small>{{ rxloanDetails.overdueAmount && format(Number(rxloanDetails.overdueAmount).toFixed(2)) }}元</small>
            </p>
            <p>
                <span>截至借款前6个月内借款人在征信报告中的逾期情况</span>
                <small>{{ rxloanDetails.otherReportInfo }}</small>
            </p>
            <p>
                <span>在其他网络借贷平台借款情况</span>
                <small>{{ rxloanDetails.otherNetloanCase }}</small>
            </p>
            <p>
                <span>在其他金融机构借款情况</span>
                <small>{{ rxloanDetails.otherFinanceCase }}</small>
            </p>
            <!-- 法人 -->
            <div v-if="rxloanDetails.borrowerTypeCode != '0'">
                <p>
                    <span>注册资本</span>
                    <small>{{ rxloanDetails.corpRegCapital }}</small>
                </p>
                <p>
                    <span>注册地址</span>
                    <small>{{ rxloanDetails.corpRegAddr }}</small>
                </p>
                <p>
                    <span>成立时间</span>
                    <small>{{ rxloanDetails.corpFoundingTime }}</small>
                </p>
                <p>
                    <span>法人代表</span>
                    <small>{{ rxloanDetails.corpRepName }}</small>
                </p>
                <p>
                    <span>股东信息</span>
                    <small>{{ rxloanDetails.corpSharehoder }}</small>
                </p>
                <p>
                    <span>法定代表人信息</span>
                    <small>{{ rxloanDetails.corpCreditInfo }}</small>
                </p>
                <p>
                    <span>实缴资本</span>
                    <small>{{ rxloanDetails.corpRealCapital }}</small>
                </p>
                <p>
                    <span>办公地点</span>
                    <small>{{ rxloanDetails.corpOfficeAddr }}</small>
                </p>
                <p>
                    <span>经营区域</span>
                    <small>{{ rxloanDetails.corpManageArea }}</small>
                </p>
            </div>
            <p>
                <span>募集期截止日</span>
                <small>{{ rxloanDetails.raiseEndTime }}</small>
            </p>
            <div class="tm-dltitle">借款项目信息：</div>
            <p>
                <span>项目名称</span>
                <small>{{ rxloanDetails.projectName }}</small>
            </p>
            <p>
                <span>项目简介</span>
                <small>{{ rxloanDetails.projectIntroduce }}</small>
            </p>
            <p>
                <span>借款金额</span>
                <small>{{ rxloanDetails.loanAmount && format(Number(rxloanDetails.loanAmount).toFixed(2)) }}元</small>
            </p>
            <p>
                <span>借款期限</span>
                <small>{{ rxloanDetails.loanExpire }}个月</small>
            </p>
            <p>
                <span>借款用途</span>
                <small>{{ rxloanDetails.loanPurpose }}</small>
            </p>
            <p>
                <span>还款方式</span>
                <small>{{ rxloanDetails.refundType }}</small>
            </p>
            <p>
                <span>借款年利率</span>
                <small>{{ rxloanDetails.loanRatio && (parseFloat(rxloanDetails.loanRatio) * 100).toFixed(2) }}%</small>
            </p>
            <p>
                <span>起息日</span>
                <small>{{ rxloanDetails.valueDate }}</small>
            </p>
            <p>
                <span>还款来源</span>
                <small>{{ rxloanDetails.repaySource }}</small>
            </p>
            <p>
                <span>保障措施</span>
                <small>
                    <a href="https://www.yirendai.com/support/safty/cjrbzjh/" class="colorGold">《保障计划》</a>
                </small>
            </p>
            <p>
                <span>项目风险评估</span>
                <small>
                    参见
                    <b class="colorGold" @click="goAssessment(8)">《风险揭示书》</b>
                </small>
            </p>
            <p>
                <span>项目撮合进度</span>
                <small>{{ rxloanDetails.projectProgress }}%</small>
            </p>
            <p>
                <span>相关费用</span>
                <small>参见《出借信息咨询与服务协议》</small>
            </p>
            <p>
                <span>合同模板</span>
                <small>
                    参见
                    <b class="colorGold" @click="goAssessment(3)">《借款协议》</b>
                </small>
            </p>
            <p>
                <span>出借人适当性管理提示</span>
                <small>{{ rxloanDetails.borrowerManage }}</small>
            </p>
        </div>
    </div>
</template>
<script>
import { bridgeRedirect } from "../../../utils/bridge";
import { formatNumber } from "@/utils/index";
import sensors from "sa-sdk-javascript";

export default {
    data() {
        return {
            rxloanDetails: {},
            jxbPrototol: {},
            token: "",
            productId: "",
            id: "" //借款号
        };
    },

    created() {
        let params = this.$route.query;
        const { token, id, productId } = params;
        this.token = decodeURIComponent(token || "");
        this.productId = productId;
        this.getData(id); //详细内容
    },
    mounted() {
        sensors.track("TMLoanDetails");
    },
    methods: {
        getData: function(code) {
            let self = this;
            this.$request({
                method: "get",
                url: `h5/borrowLoans/borrowLoansDetail/${code}`
            })
                .then(res => {
                    const { data } = res;
                    self.rxloanDetails = data;
                })
                .catch(err => {
                    this.$toast(err);
                });
        },

        goAssessment: function(type) {
            bridgeRedirect(`${location.origin}${location.pathname}#/loanAgreement?token=${this.token}&productId=${this.productId}&protocolType=${type}`);
        },
        format(num) {
            return formatNumber(num);
        }
    }
};
</script>
<style lang="less">
@import "../css/inforDetail.less";

.tm-detail {
    span {
        display: inline-block;
        width: 172px;
    }

    small {
        text-align: right;
    }
}
</style>
